var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dot-loader",style:({ width: _vm.width, height: _vm.height })},[_c('Lottie',{staticClass:"dot-loader-lottie",attrs:{"options":_vm.animationOptions,"width":94,"height":72}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }